const WalletCard = ({ balance = 0, pendingBalance = 0, totalPaid = 0, onWithdraw = null }) => (
  <div className="wallet-card">
    <div className="wallet-top">
      <span className="wallet-label"><i className="fa-solid fa-wallet" /> Solde disponible</span>
      <span className="wallet-dots">•••</span>
    </div>
    <strong>{Number(balance || 0).toLocaleString()} <small>Ar</small></strong>
    <div className="wallet-meta">
      <span>En attente <b>{Number(pendingBalance || 0).toLocaleString()} Ar</b></span>
      <span>Total versé <b>{Number(totalPaid || 0).toLocaleString()} Ar</b></span>
    </div>
    {onWithdraw && (
      <button type="button" className="wallet-withdraw" onClick={onWithdraw}>
        <i className="fa-solid fa-money-bill-transfer" /> Retirer vers Mobile Money
      </button>
    )}
    <div className="wallet-footer">
      <span>Revenus nets • Mobile Money</span>
      <span className="wallet-wave">∿∿∿</span>
    </div>
  </div>
);

export default WalletCard;
